import swiper from './swiper.js'
import observer from './observer.js'
import {Button,Navbar} from '../components/index.js'